module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [_c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_c('div', {
    staticClass: "col-md-12 market-update-left"
  }, [_c('h4', [_vm._v("Total Referrals")]), _vm._v(" "), (_vm.users) ? _c('h3', [_vm._v(_vm._s(_vm.total_referrals))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n       Referral Transactions\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "notifications"
  }, [_c('table', {
    staticClass: "table hidden-sm hidden-xs"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referrer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('td', [_c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed to earn reward'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_status))])])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table hidden-md hidden-lg"
  }, _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referrer: ")]), _vm._v(_vm._s(ref.referral_referrer))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referred: ")]), _vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward Progress: ")]), _c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed to earn reward'
      }
    })]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(ref.referral_status))])])])
  }))])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("Referrer")]), _vm._v(" "), _c('th', [_vm._v("Referred")]), _vm._v(" "), _c('th', [_vm._v("Reward Progress")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef8d4d8"}!./src/components/Referrals/template.html
// module id = 156
// module chunks = 0